import React from 'react';
import Calendar from "../DatePicker/DatePicker";

import calendarGreen from '../img/calendarGreen.svg';
import calendarOrange from '../img/calendarOrange.svg';

const SubInputs = ({
                       handleChangeFuncProps,
                       handleChangeStateOfAdditional,
                       stateBoxShadowProps,
                       stateVariableProps,
                       stateAdditionalItem1Props,
                       stateAdditionalItem2Props,
                       stateAdditionalItem3Props,
                       objSubProps,
                       handleChangeDateFuncProps,
                       stateBirthDayProps,
                       lostProps,
                       findProps,
                   }) => {

    const objSecret = {
        passport: stateAdditionalItem3Props,
        techPassport: [...stateAdditionalItem2Props].reverse().slice(0,2).reverse().join(''),
        driverLicense: stateAdditionalItem3Props,
        animal: 'загрузите фото',
        purse: stateAdditionalItem2Props,
        keys: stateAdditionalItem2Props,
        plateNumber: [...stateAdditionalItem1Props].reverse().slice(0,2).reverse().join(''),
        kievCard: stateAdditionalItem3Props,
        other: stateAdditionalItem3Props,
    }

    return (
        <div className="box">
            {objSubProps[stateVariableProps].item1 && <div className="formStep-item">
                <div className="formStep-inputWrapper">
                    <input
                        className={stateBoxShadowProps === 'additionalItem1' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                        data-name="additionalItem1" name="additionalItem1"
                        value={stateAdditionalItem1Props}
                        onChange={handleChangeFuncProps}
                        placeholder={objSubProps[stateVariableProps].item1}
                    />
                </div>
                <span className="formStep-item__text">{objSubProps[stateVariableProps].item1}</span>
            </div>}
            {objSubProps[stateVariableProps].item2 && <div className="formStep-item">
                <div className="formStep-inputWrapper">
                    <input
                        className={stateBoxShadowProps === 'additionalItem2' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                        data-name="additionalItem2" name="additionalItem2"
                        value={stateAdditionalItem2Props}
                        onChange={handleChangeFuncProps}
                        placeholder={objSubProps[stateVariableProps].item2}/>
                </div>
                <span className="formStep-item__text">{objSubProps[stateVariableProps].item2}</span>
            </div>}
            {objSubProps[stateVariableProps].item3 && <div className="formStep-item">
                <div className="formStep-inputWrapper">
                    <input
                        className={stateBoxShadowProps === 'additionalItem3' ? 'formStep-input formStep-inputBoxShadow' : "formStep-input"}
                        data-name="additionalItem3" name="additionalItem3"
                        value={stateAdditionalItem3Props}
                        onChange={handleChangeFuncProps}
                        placeholder={objSubProps[stateVariableProps].item3}/>
                </div>
                <span className="formStep-item__text">{objSubProps[stateVariableProps].item3}</span>
            </div>}
            {objSubProps[stateVariableProps].item4 && <div className="formStep-item">
                <div className="formStep-inputWrapper">
                    <Calendar
                        classProps={'calendar'}
                        changeDateFunc={handleChangeDateFuncProps}
                        startDateProps={stateBirthDayProps}
                    />
                    <div className="formStep-calendarImgBox">
                        <img
                            src={(findProps && calendarGreen) || (lostProps && calendarOrange)}
                            alt=""
                            className="formStep-calendarImg"/>
                    </div>
                </div>
                <span className="formStep-item__text">{objSubProps[stateVariableProps].item4}</span>
            </div>}
            {stateVariableProps !== 'animal' ? <div className="formStep-item">
                <div className="formStep-inputWrapper">
                    <p className='formStep-inputSecret' id="secretCodeId">{objSecret[stateVariableProps]}</p>
                </div>
                <span className="formStep-item__text">{objSubProps.secretCodeComment}</span>
            </div> : null}
        </div>
    )
}

export default SubInputs;
